export const isStringEmpty = (input: string): boolean => {
  return input.trim().length === 0;
};
